export default __webpack_public_path__ + "static/media/particles-mobile-theme1.ff0c3dc6.svg";